// Centralised data-testid constants — kebab-case, descriptive of function.
export const TID = {
  // Navigation
  navRoot: 'site-nav',
  navLogo: 'nav-logo',
  navLinkHome: 'nav-link-home',
  navLinkHotel: 'nav-link-hotel',
  navLinkPackages: 'nav-link-packages',
  navLinkVisa: 'nav-link-visa',
  navLinkTransport: 'nav-link-transport',
  navLinkAbout: 'nav-link-about',
  navLinkContact: 'nav-link-contact',
  navCtaPlan: 'nav-cta-plan-journey',
  navMobileToggle: 'nav-mobile-toggle',
  navMobileSheet: 'nav-mobile-sheet',

  // Hero
  heroSection: 'hero-section',
  heroPrimaryCta: 'hero-cta-plan-journey',
  heroSecondaryCta: 'hero-cta-explore-packages',
  heroScrollHint: 'hero-scroll-hint',

  // Pillars
  pillarHotel: 'pillar-hotel',
  pillarVisa: 'pillar-visa',
  pillarTransport: 'pillar-transport',
  pillarPackages: 'pillar-packages',

  // Hotel
  hotelSection: 'hotel-section',
  hotelCtaInquire: 'hotel-cta-inquire',

  // Packages
  packagesSection: 'packages-section',
  packageCard: (slug) => `package-card-${slug}`,
  packageCardCta: (slug) => `package-card-cta-${slug}`,

  // Visa
  visaSection: 'visa-section',
  visaCta: 'visa-cta-apply',

  // Transport
  transportSection: 'transport-section',
  transportCta: 'transport-cta-book',

  // Testimonials
  testimonialsSection: 'testimonials-section',
  testimonialPrev: 'testimonial-prev',
  testimonialNext: 'testimonial-next',

  // FAQ
  faqSection: 'faq-section',
  faqItem: (i) => `faq-item-${i}`,

  // Inquiry form
  inquirySection: 'inquiry-section',
  inquiryForm: 'inquiry-form',
  inquiryFieldName: 'inquiry-field-guest-name',
  inquiryFieldContact: 'inquiry-field-contact',
  inquiryFieldEmail: 'inquiry-field-email',
  inquiryFieldCity: 'inquiry-field-city-of-origin',
  inquiryFieldNationality: 'inquiry-field-nationality',
  inquiryFieldCheckin: 'inquiry-field-checkin',
  inquiryFieldCheckout: 'inquiry-field-checkout',
  inquiryFieldRoomType: 'inquiry-field-room-type',
  inquiryFieldRoomCount: 'inquiry-field-room-count',
  inquiryFieldBeds: 'inquiry-field-bed-count',
  inquiryFieldPax: 'inquiry-field-pax',
  inquiryFieldChildren: 'inquiry-field-child-count',
  inquiryFieldCity_Karbala: 'inquiry-city-karbala',
  inquiryFieldCity_Najaf: 'inquiry-city-najaf',
  inquiryFieldCity_Kadhimiya: 'inquiry-city-kadhimiya',
  inquiryFieldCity_Samarra: 'inquiry-city-samarra',
  inquiryFieldService_Hotel: 'inquiry-service-hotel',
  inquiryFieldService_Visa: 'inquiry-service-visa',
  inquiryFieldService_Transport: 'inquiry-service-transport',
  inquiryFieldService_Package: 'inquiry-service-package',
  inquiryFieldBudget: 'inquiry-field-budget',
  inquiryFieldNotes: 'inquiry-field-notes',
  inquirySubmit: 'inquiry-submit',
  inquirySuccess: 'inquiry-success',
  inquiryError: 'inquiry-error',

  // Floating
  whatsappFab: 'whatsapp-fab',

  // Footer
  footerRoot: 'site-footer',
  footerCta: 'footer-cta-plan',

  // Packages page
  packagesPage: 'packages-page',
  packagesFilterAll: 'packages-filter-all',
  packagesFilterKarbala: 'packages-filter-karbala',
  packagesFilterNajaf: 'packages-filter-najaf',
  packagesFilterCombined: 'packages-filter-combined',

  // Contact page
  contactPage: 'contact-page',
};
